import React, { useState } from "react";
import a3 from "../Accests/images/bonfire/IMG-20250630-WA0014.jpg";
import a4 from "../Accests/images/bonfire/IMG-20250630-WA0015.jpg";
import a5 from "../Accests/images/bonfire/IMG-20250630-WA0016.jpg";
import a6 from "../Accests/images/bonfire/IMG-20250630-WA0018.jpg";
import a7 from "../Accests/images/bonfire/IMG-20250630-WA0019.jpg";
import a8 from "../Accests/images/bonfire/IMG-20250630-WA0020.jpg";
import a9 from "../Accests/images/bonfire/IMG-20250630-WA0024.jpg";
import a10 from "../Accests/images/bonfire/IMG-20250630-WA0025.jpg";
import v1 from "../Accests/images/bonfire/VID-20250630-WA0001.mp4";
import v2 from "../Accests/images/bonfire/VID-20250630-WA0007.mp4";

const Bonfire = () => {
    const [previewSrc, setPreviewSrc] = useState(null);
    const [isVideo, setIsVideo] = useState(false);

    const openPreview = (src, type) => {
        setPreviewSrc(src);
        setIsVideo(type === "video");
    };

    const closePreview = () => {
        setPreviewSrc(null);
        setIsVideo(false);
    };

    return (
        <>
            <div className="pt-24 px-6 bg-gray-100 min-h-screen">
                <h1 className="text-4xl font-bold text-center mb-8 text-orange-600">Bonfire</h1>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                    {[a3, a4, a5, a6, a7, a8, a9, a10].map((img, index) => (
                        <img
                            key={index}
                            src={img}
                            alt={`Bonfire ${index + 1}`}
                            onClick={() => openPreview(img, "image")}
                            className="w-full h-64 object-cover rounded-lg cursor-pointer shadow hover:scale-105 transition"
                        />
                    ))}

                    {[v1, v2].map((video, index) => (
                        <video
                            key={index}
                            src={video}
                            onClick={() => openPreview(video, "video")}
                            className="w-full h-64 object-cover rounded-lg cursor-pointer shadow hover:scale-105 transition"
                            muted
                            autoPlay
                            loop
                        />
                    ))}
                </div>

                <p className="text-gray-700 mt-6 text-lg leading-relaxed">
                    Join us for a vibrant beach bonfire party filled with laughter, music, and unforgettable views.
                    Enjoy the warm glow of the fire and the sound of waves under a starlit sky.
                </p>
            </div>

            {/* Preview Modal */}
            {previewSrc && (
                <div className="fixed inset-0 bg-black bg-opacity-90 flex items-center justify-center z-50">
                    {/* Clickable background to close */}
                    <div className="absolute inset-0" onClick={closePreview}></div>

                    <div className="relative z-10 max-w-4xl w-full p-4">
                        <button
                            onClick={closePreview}
                            className="absolute top-4 right-4 z-20 bg-white text-black rounded-full w-10 h-10 flex items-center justify-center text-2xl font-bold hover:bg-red-600 hover:text-white transition"
                        >
                            &times;
                        </button>
                        {isVideo ? (
                            <video src={previewSrc} className="w-full rounded-lg" controls autoPlay />
                        ) : (
                            <img src={previewSrc} alt="Preview" className="w-full rounded-lg" />
                        )}
                    </div>
                </div>
            )}
        </>
    );
};

export default Bonfire;
